import React, { Component } from 'react';
import TagsInput from 'react-tagsinput';

// import 'react-tagsinput/react-tagsinput.css'; // If using WebPack and style-loader.

class TagsSelector extends Component {
    state = { inputValue: '' };
    _onChange = (tags) => {
        this.props.onChange && this.props.onChange(tags, this.props.name);
    };
    _onChangeInput = (inputValue) => {
        this.setState({ inputValue });
    };
    render() {
        return (
            <TagsInput
                inputProps={{ placeholder: '' }}
                className={`ckp-tags-input ${!!this.state.inputValue ? 'is-with-input' : ''}`}
                onChange={this._onChange}
                value={this.props.value}
                inputValue={this.state.inputValue}
                onChangeInput={this._onChangeInput}
            />
        );
    }
}

export default TagsSelector;



// WEBPACK FOOTER //
// ./src/components/admin/forms/TagsSelector.js